// app/javascript/controllers/modal_controller.js
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['background', 'container']

  open(event) {
    event.preventDefault()
    this.backgroundTarget.classList.remove('hidden')
    this.containerTarget.classList.remove('hidden')
  }

  close(event) {
    event.preventDefault()
    this.backgroundTarget.classList.add('hidden')
    this.containerTarget.classList.add('hidden')
  }
}
